// extracted by mini-css-extract-plugin
export default {"header":"css_header__zkx2r","subtitle":"css_subtitle__i06n6","title":"css_title__Q8UL9","headerCenter":"css_headerCenter__MkI3X"};